export class TabDTO{
  id: string;
  tabInfo: string;
}
